
module.exports = function equal(arr1, arr2) {
  var length = arr1.length
  if (length !== arr2.length) return false
  for (var i = 0; i < length; i++)
    if (arr1[i] !== arr2[i])
      return false
  return true
}



//////////////////
// WEBPACK FOOTER
// ./~/array-equal/index.js
// module id = 17
// module chunks = 0